import React from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';

class OrdersPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { orders: [], loading: true };
  }

  componentDidMount() {
    if (this.props.customer) this.loadOrders();
  }

  loadOrders() {
    api.getMyOrders()
      .then((orders) => this.setState({ orders, loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    const { customer } = this.props;
    if (!customer) {
      return (
        <div className="auth-page">
          <h1>My Orders</h1>
          <p>Please <Link to="/login">log in</Link> to see your order history.</p>
        </div>
      );
    }

    const { orders, loading } = this.state;
    if (loading) return <p className="loading">Loading your orders...</p>;

    if (!orders.length) {
      return (
        <div className="orders-page">
          <h1>My Orders</h1>
          <p>No orders yet. <Link to="/products">Browse licenses</Link> to get started.</p>
        </div>
      );
    }

    return (
      <div className="orders-page">
        <h1>My Orders</h1>
        <div className="orders-list">
          {orders.map((o) => (
            <div key={o.id} className="order-card">
              <div className="order-card-header">
                <div>
                  <strong>{o.reference}</strong>
                  <span className="order-date">{new Date(o.createdAt).toLocaleDateString()}</span>
                </div>
                <span className={`badge badge-${o.status === 'fulfilled' ? 'shared' : 'private'}`}>{o.status}</span>
              </div>
              <ul className="order-items">
                {o.items.map((item, idx) => (
                  <li key={idx}>
                    {item.productName} — {item.licenseType === 'shared' ? 'Shared' : 'Private'} &times; {item.quantity}
                  </li>
                ))}
              </ul>
              <div className="order-card-footer">
                <span>Total: ₦{Number(o.total).toLocaleString()}</span>
                {o.status === 'fulfilled' && <span className="hint">License sent to your email</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default OrdersPage;
